import dynamic from 'next/dynamic';
// import FloatPic from '@elem/compCommon/FloatPic';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';

export default function IncentivesAndPolicy() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const { useLang } = useGlobal();

    const { t } = useLang('incentivesandpolicy');

    const richText = (key: string) => {
        return t.rich(key, {
            strong: (text: string) => `<strong>${text}</strong>`,
            sup: (text: string) => `<sup>${text}</sup>`,
        });
    }

    const items = [
        {
            text: richText('desc1'),
        },
        {
            text: richText('desc2'),
        },
        {
            text: richText('desc3'),
        },
        {
            text: richText('desc4'),
            href: 'https://www.irs.gov/credits-deductions/residential-clean-energy-credit',
        },
        {
            text: richText('desc5'),
        },
        {
            text: richText('desc6'),
        },
        {
            text: richText('desc7'),
            children: [
                { text: richText('desc7-1') },
                { text: richText('desc7-2') },
                { text: richText('desc7-3') },
            ]
        },
        {
            text: richText('desc8'),
        },
        {
            text: richText('desc9'),
        },
        {
            text: richText('desc10'),
        },
        {
            text: richText('desc11'),
            href: 'https://www.congress.gov',
        },
        {
            text: richText('desc12'),
        },
        {
            text: richText('desc12-1'),
        },
        {
            text: richText('desc13'),
            href: 'https://www.ecoflow.com/us/ocean-pro-consultation',
        },
        {
            text: richText('desc14'),
            href: 'https://www.ecoflow.com/us/ocean-pro-home-solar-battery',
        },
        {
            text: richText('desc15'),
            style: { 'margin': '60px 0 0 0' }
        },
        {
            text: richText('desc16'),
        }
    ]
    return (
        <div className={`${css['policy']}`}>
            <div className="wrap">
                {
                    items.map((item, index) => (
                        <>
                            {item.href ? (
                                <a href={item.href}>{item.text}</a>
                            ) : (
                                <p style={item.style} dangerouslySetInnerHTML={{ __html: item.text }}></p >

                            )}
                            <p><br /></p>
                            {item.children && (
                                <>
                                    <ol>
                                        {item.children.map((child, childIndex) => (
                                            <li key={childIndex} dangerouslySetInnerHTML={{ __html: child.text }}></li>
                                        ))}
                                    </ol>
                                    <p><br /></p>
                                </>
                            )}
                        </>
                    ))
                }

            </div>
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div >
    );
}
